export const Seven = 'g';